import React from 'react';
import PropTypes from 'prop-types';
import PrismSortToggle from './prismSortToggle';
import PrismSortToggleMenu from './prismSortToggleMenu';

import { SORT_COLUMN_PROP_TYPES, SORT_DIRECTION_PROP_TYPES } from './constants'

class PrismSort extends React.PureComponent {
    static propTypes = {
        sortColumns: PropTypes.arrayOf(SORT_COLUMN_PROP_TYPES).isRequired,
        sortBy: PropTypes.string,
        sortDirection: SORT_DIRECTION_PROP_TYPES.isRequired,
        onSortSelect: PropTypes.func.isRequired
    };

    state = {
        isOpened: false,
    };

    constructor(props) {
        super(props);

        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.handleToggleMenu = this.handleToggleMenu.bind(this);
    }

    componentDidMount() {
        if (typeof document !== 'undefined') {
            document.addEventListener('mousedown', this.handleClickOutside, false);
        }
    }

    componentWillUnmount() {
        if (typeof document !== 'undefined') {
          document.removeEventListener('mousedown', this.handleClickOutside, false);
        }
    }

    handleClickOutside = e => {
        if (this.element && this.element.contains(e.target)) {
            return;
        }

        this.setState({ isOpened: false });
    }

    handleToggleMenu = e => {
        e.preventDefault();

        const { isOpened } = this.state;
        this.setState({ isOpened: !isOpened });
    }

    render() {
        const { isOpened } = this.state;

        return (
            <div
                ref={element => this.element = element}
                className='prism-sort prism-sandbox'
            >
                <PrismSortToggle
                    {...this.props}
                    onToggle={this.handleToggleMenu}
                />
                <PrismSortToggleMenu
                    {...this.props}
                    isOpened={isOpened}
                />
            </div>
        );
    }
}

export default PrismSort;
